import React from 'react'
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Grid,
  Typography,
} from '@mui/material'
import PlainModal from '../../../components/modal/PlainModal'
import { IconArrowRight, IconX } from '@tabler/icons-react'
import { avatarImages } from '../../../helpers/static-constants'
import {
  selectIsInfluencerModalOpen,
  setIsInfluencerModalOpen,
  setIsInfluencerOnboardModalOpen,
} from '../../../store/influencer/contentCreator'
import { useAppSelector } from '../../../store'
import useAppUtilities from '../../../hooks/useAppUtilities'
import { useAuth0 } from '@auth0/auth0-react'
import { useAuthHelper } from '../../../hooks/useAuthHelper'

const RegisterInfluencerModal: React.FC = () => {
  const { dispatch } = useAppUtilities()
  const { isAuthenticated } = useAuth0()
  const { loginAuthUser } = useAuthHelper()
  const isInfluencerModalOpen = useAppSelector(selectIsInfluencerModalOpen)
  const onCloseInfluencerModal = (): void => {
    dispatch(setIsInfluencerModalOpen(false))
  }

  const onApplyContentCreator = (): void => {
    if (isAuthenticated) {
      dispatch(setIsInfluencerModalOpen(false))
      dispatch(setIsInfluencerOnboardModalOpen(true))
    } else {
      loginAuthUser()
    }
  }
  return (
    <PlainModal
      open={isInfluencerModalOpen}
      handleClose={onCloseInfluencerModal}
      modelWidth="800px"
      borderNone
    >
      <Grid container>
        <Grid item xs={6}>
          <Box
            component="img"
            src="/new/images/influencer-signup-modal.png"
            height="100%"
            width="100%"
            sx={{
              borderTopLeftRadius: '16px',
              borderBottomLeftRadius: '16px',
            }}
          ></Box>
        </Grid>
        <Grid
          item
          xs={6}
          overflow="hidden"
          sx={{
            borderBottomRightRadius: '16px',
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="relative"
            height="100%"
            width="100%"
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              p={3}
            >
              <Box>
                <Typography variant="h3">Are You a Content Creator?</Typography>
                <Typography variant="h3">
                  Work with Restaurants Today!
                </Typography>
              </Box>
              <Typography
                variant="subtitle1"
                color="grey.500"
                textAlign="center"
                mt={1}
              >
                Influencers like you can now connect with restaurants for paid
                collabs! Create Influencer profile to explore campaigns and land
                exciting sponsorships!
              </Typography>
              <Button
                endIcon={<IconArrowRight stroke={2} />}
                sx={{
                  mt: '40px',
                }}
                fullWidth
                variant="contained"
                onClick={onApplyContentCreator}
              >
                Register as an Influencer with us
              </Button>
            </Box>
            <Box
              position="absolute"
              bottom={-7}
              left={-10}
              display="flex"
              overflow="hidden"
            >
              <AvatarGroup
                max={9}
                spacing={13}
                sx={{
                  zIndex: -1,
                }}
              >
                {avatarImages.map((src, index) => (
                  <Avatar
                    key={index}
                    alt={`Avatar ${index + 1}`}
                    src={src}
                    sx={{
                      width: ['46px', '50px', '54px'],
                      height: ['46px', '50px', '54px'],
                    }}
                  />
                ))}
              </AvatarGroup>
            </Box>
            <Box position="absolute" top="0" right="0" display="flex" p={2}>
              <IconX
                size={20}
                stroke={2}
                style={{ cursor: 'pointer' }}
                onClick={onCloseInfluencerModal}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </PlainModal>
  )
}

export default RegisterInfluencerModal
